export default __webpack_public_path__ + "media/cuttlefish/activeProBadge-74268730.svg";